import React, { Component } from 'react'
import { CSSTransition } from './CSSTransition'
import PdfComponent from './PdfComponent';
import VideoComponent from './VideoComponent';
import ListingRow from './ListingRow';
import ListingHeader from './ListingHeader';
import DetailsSection from './DetailsSection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import { dlClosePage, dlShowChildren } from '../DataLayer';
import Showdown from 'showdown';
import { withTranslation } from 'react-i18next';
import QRCode from 'qrcode.react';
import Iframe from './Iframe';

import { compareListingValues, getLowestSortValue, makeSortedDirs, sortListingsByCols } from '../util/listings';
import { formatStringToClass } from '../util/format';
import { condorComponentENV, envENV } from '../ENV';
import DetailActionContext from '../util/DetailActionContext';
import { addComposedClasses, removeComposedClasses } from '../util/classList';
import { TOUCH_ACTION_DIRECT_WAYFINDING } from '../util/touchActions';

import {
	WayfindingComponent,
} from '@touchsource/wayfinding_lib';

const converter = new Showdown.Converter();

const columnsNotToRender = ['row_key', 'row_hash', 'landmark_id', 'mall_store_url'];

class ListingsDetails extends Component {
	static contextType = DetailActionContext;

	constructor(props) {
		super(props);

		this.state = {
			activeButton: '',
			buttonClicked: false,
			css: props.CSSModules['ListingsDetails'],
			markerEnd: '',
			markerStyle: '',
			pathStyle: '',
			tieredDetails: [],
			tieredHeaders: [],
			touchAction: '',
			showModal: false,
			showIframe: false,
			showVideo: false,
			pdfFiles: {},
			currentPdf: '',
			currentIframe: '',
			currentVideo: '',
			listings: props.defaultList.listings,
			wayfindingReady: false,
			iframeClosedByUser: false, // Prevents auto-reopen after user closes iframe
		};
		this.scrollWindow = React.createRef();
		this.scrollUpBtn = React.createRef();
		this.scrollDownBtn = React.createRef();
		this.startScrolling = this.startScrolling.bind(this);
		this.stopScrolling = this.stopScrolling.bind(this);
		this.buttonClickTimer = null;
		this.buttonDelayTimer = null;
		this.wayfindingRef = React.createRef();
		this.wayfindingInitTimeout = null;
		this.wayfindingMounted = false;

		this.detailsRef = React.createRef();
		this.pdfRef = React.createRef();
		this.videoRef = React.createRef();
		this.iframeRef = React.createRef();

		// Memoization for WayfindingComponent props
		this.memoizedFlatData = null;
		this.memoizedFlatDataHash = '';

		// Track recursion depth for buildListingsNew
		this.buildingDepth = 0;
		this.mounted = false;
	}

	// Add shouldComponentUpdate
	shouldComponentUpdate(nextProps, nextState) {
		// Prevent re-renders during wayfinding animation
		if (this.state.touchAction === 7 && 
			this.state.pathStyle !== nextState.pathStyle && 
			nextState.pathStyle === 'animatePath') {
			return false; // Skip render during path animation
		}
		
		// Add deep comparison for complex objects
		if (this.props.detailsGrp !== nextProps.detailsGrp) {
			if (JSON.stringify(this.props.detailsGrp) === JSON.stringify(nextProps.detailsGrp)) {
				return false; // Same content, skip render
			}
		}
		
		// Only update on specific prop/state changes
		return (
			this.props.defaultList !== nextProps.defaultList ||
			this.props.detailsPage !== nextProps.detailsPage ||
			this.props.detailsUUID !== nextProps.detailsUUID ||
			this.props.details !== nextProps.details ||
			this.props.navProps?.adaActive !== nextProps.navProps?.adaActive ||
			this.state.showModal !== nextState.showModal ||
			this.state.showIframe !== nextState.showIframe ||
			this.state.showVideo !== nextState.showVideo ||
			this.state.currentPdf !== nextState.currentPdf ||
			this.state.currentIframe !== nextState.currentIframe ||
			this.state.currentVideo !== nextState.currentVideo ||
			this.state.tieredDetails !== nextState.tieredDetails ||
			this.state.markerEnd !== nextState.markerEnd ||
			this.state.markerStyle !== nextState.markerStyle ||
			this.state.useNearbyLocation !== nextState.useNearbyLocation ||
			this.state.pathStyle !== nextState.pathStyle ||
			this.state.wayfindingReady !== nextState.wayfindingReady
		);
	}

	componentDidMount() {
		this.mounted = true;
		this.buildListingsNew(this.state.listings, []);

		this.resizeObserver = new ResizeObserver(() => {
			const { css } = this.state;

			if (!(this.scrollUpBtn.current && this.scrollDownBtn.current && css.disabledButton)) {
				return;
			}

			if (this.scrollWindow.current?.scrollHeight > this.scrollWindow.current?.clientHeight) {
				removeComposedClasses(this.scrollUpBtn.current, css.disabledButton);
				removeComposedClasses(this.scrollDownBtn.current, css.disabledButton);
			} else if (this.scrollWindow.current?.scrollHeight <= this.scrollWindow.current?.clientHeight) {
				addComposedClasses(this.scrollUpBtn.current, css.disabledButton);
				addComposedClasses(this.scrollDownBtn.current, css.disabledButton);
			}
		});

		this.resizeObserver.observe(this.scrollWindow.current);
	}

	componentWillUnmount = () => {
		clearTimeout(this.onMountTimeout);
		clearTimeout(this.animateTimeout);
		clearTimeout(this.buttonClickTimer);
		clearTimeout(this.buttonDelayTimer);
		clearTimeout(this.wayfindingInitTimeout);
		clearInterval(this.timer); // React 19 fix: Clear scroll interval to prevent memory leak

		this.mounted = false;
		this.wayfindingMounted = false;

		this.props.handleDetailsUnmount();

		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
			this.resizeObserver = null;
		}

		// Clear wayfinding ref
		if (this.wayfindingRef.current) {
			this.wayfindingRef.current = null;
		}
	}


	toggleModal = (value) => {
		if (this.state.buttonClicked === false) {
			this.props.navEvents('togglePdf');
			if (this.context.currentDetailAction === 12) {
				this.setState({
					currentPdf: value,
					showModal: !this.state.showModal,
				});
			} else {
				this.setState({
					currentPdf: value,
					showModal: !this.state.showModal
				});
			}
		}

		this.setState({
			buttonClicked: true,
		})

		clearTimeout(this.buttonClickTimer);
		this.buttonClickTimer = setTimeout(() => {
			this.setState({
				buttonClicked: false,
			})
		}, 700)
	}

	toggleVideo = (value) => {
		if (this.state.buttonClicked === false) {
			this.props.navEvents('togglePdf');
			this.setState({
				currentVideo: value,
				showVideo: !this.state.showVideo,
			});
		}

		this.setState({
			buttonClicked: true,
		})

		clearTimeout(this.buttonClickTimer);
		this.buttonClickTimer = setTimeout(() => {
			this.setState({
				buttonClicked: false,
			})
		}, 700)
	}

	// React 19 fix: Handle phase change after modal exit animation completes
	handleModalExited = () => {
		if (this.pendingPhaseChange) {
			this.pendingPhaseChange = false;
			const modalType = this.pendingModalType;
			const touchAction = this.pendingTouchAction;

			// Clear modal content now that exit animation is done
			this.setState({
				currentPdf: '',
				currentIframe: '',
				currentVideo: '',
			});

			// Call appropriate navigation event based on original context
			if (touchAction === 12 || touchAction === 11 || touchAction === 13) {
				// Reset the active states before navigating back to prevent buttons staying greyed out
				if (touchAction === 12 || modalType === 'pdf' || modalType === 'video') {
					this.props.navEvents('closePdf');
				}
				if (touchAction === 11 || modalType === 'iframe') {
					this.props.navEvents('toggleIframe');
				}
				this.props.goBack();
			} else if (modalType === 'pdf' || modalType === 'video') {
				this.props.navEvents('togglePdf');
			} else {
				this.props.navEvents('toggleIframe');
			}
		}
	}

	closeModal = (modalType) => {
		if (this.state.buttonClicked === false) {
			// React 19 fix: For ALL cases, close modal first, then trigger phase change via onExited callback
			// This prevents navigation from appearing before modal finishes closing
			this.pendingPhaseChange = true;
			this.pendingModalType = modalType;
			this.pendingTouchAction = this.props.detailsTouchAction;

			// Only set show* to false to trigger exit animation.
			// Don't clear current* content yet - keep it visible during the fade-out
			// to prevent white flash. Content is cleared in handleModalExited after animation.
			this.setState({
				showModal: false,
				showIframe: false,
				showVideo: false,
				iframeClosedByUser: modalType === 'iframe', // Prevent iframe from auto-reopening
			});
		}

		this.setState({
			buttonClicked: true,
		})

		clearTimeout(this.buttonClickTimer);
		this.buttonClickTimer = setTimeout(() => {
			this.setState({
				buttonClicked: false,
			})
		}, 700)
	}

	toggleIframe = (value) => {
		if (value !== undefined && value !== '') {
			this.setState({
				currentIframe: value,
				showIframe: !this.state.showIframe
			});
		} else if (value === 'closeIframe') {
			this.props.goBack();
		}
	}

	formatTime(i) {
		if (i < 10) {
			i = `0${i}`;
		}
		return i;
	}

	getTime() {
		let now = new Date();
		let h = now.getHours();
		let m = now.getMinutes();
		let s = now.getSeconds();

		h = this.formatTime(h);
		m = this.formatTime(m);
		s = this.formatTime(s);

		let time = `${h}:${m}:${s}`;
		return time;
	}

	startScrolling = (direction) => {
		let value = 0;
		if (this.props.scrollButtons === 1) {
			if (direction === 'down') {
				value = 2
			} else if (direction === 'up') {
				value = -2
			}
		} else if (this.props.scrollButtons === 2) {
			if (direction === 'down') {
				value = this.props.scrollDistance
			} else if (direction === 'up') {
				value = -(this.props.scrollDistance)
			}
		}

		if (this.props.scrollButtons === 1) {
			this.timer = setInterval(() => {
				this.scrollWindow.current.scrollTop += value;
			}, 5);
		} else if (this.props.scrollButtons === 2) {
			this.scrollWindow.current.scrollTop += value;
			this.timer = setInterval(() => {
				this.scrollWindow.current.scrollTop += value;
			}, 1000);
		}
	}

	stopScrolling = () => {
		clearInterval(this.timer);
	}

	buildListingsNew = (listingsArray, rowsArray = [], forceProcess = false) => {
		// Only prevent recursive calls when not forcing - allow forced processing even during building
		if (this.buildingDepth > 0 && !forceProcess) {
			return;
		}
		
		// Add early return for wayfinding to prevent unnecessary rebuilds
		// But always allow rebuild when detailsUUID has changed (navigating to a different listing)
		if (this.state.touchAction === 7 && this.state.tieredDetails.length > 0 && this.state.wayfindingReady && this._lastProcessedUUID === this.props.detailsUUID) {
			return; // Skip rebuild if wayfinding is already initialized for this listing
		}
		this._lastProcessedUUID = this.props.detailsUUID;
		
		// Track recursion depth
		this.buildingDepth++;
		const isTopLevel = this.buildingDepth === 1;
		
		let rowHeaders = [];
		let tieredHeaders = [];
		let css = this.state.css;
		let numberOfResults = 0
		let touchAction = ''
		let lastEffectiveTouchAction = null;
		// For translation
		const { t } = this.props;

		listingsArray.forEach((listing, j) => {
			let boxStyleDisplay;
			if (listing.m1Key === this.props.detailsUUID || forceProcess) {
				let headerWidths = [];
				let textAlign = [];

				if (listing.listings.length > 0) {
					listing.listings[0].colGroups.forEach(colGroup => {
						headerWidths.push(colGroup.width);
						textAlign.push(this.buildTextAlign(colGroup.textAlign))
					});
				}

				touchAction = listing.tierConfig.touchAction;

				if (listing.listings.length > 0) {
					let sortedCols = [...listing.listings[0].colGroups].filter((c) => {
						if (c.sort > 0) {
							return true;
						}

						return false;
					});

					sortedCols.sort((i, j) => {
						if (i.sort > j.sort) {
							return 1;
						}

						return -1;
					});

					listing.listings = listing.listings.map((listing) => {
						listing.sortedVals = [listing.rank || 0];

						for (let col of sortedCols) {
							listing.sortedVals.push(listing.vals[col.order - 1]);
						}

						return listing;
					});

					const sortedDirs = makeSortedDirs(sortedCols);

					listing.listings.sort((a, b) => {
						return sortListingsByCols(a, b, sortedDirs);
					});
				}

				listing.listings.forEach((row, i) => {
					// Check if this row itself is the one we're looking for
					if (row.m1Key === this.props.detailsUUID && row.listings && row.listings.length > 0) {
						// Recursively process this row's children
						this.buildListingsNew(row.listings, rowsArray);
						touchAction = row.tierConfig?.touchAction || touchAction;
						return; // Skip processing this row as a regular row
					}
					
					if (numberOfResults < 500) {
						numberOfResults++

						let currentHeaderWidths = row.colGroups.map(colGroup => {
							return colGroup.width
						});
						boxStyleDisplay = row.tierConfig.boxStyleDisplay
						let listingsWithType = []
						let headersArray = []
						row.colGroups.forEach((col) => {
							if (col.headerAsLabel) {
								headersArray.push(col.name)
							} else {
								headersArray.push('');
							}
						})
						row.vals.forEach((listingData, i) => {
								listingsWithType.push({
									value: listingData,
									type: listing.listings[0].types[i],
									displayName: listing.listings[0].displayNames[i],
									column_uuid: listing.listings[0].colGroups[i]?.m1Key
								});
						})
						// add tierConfig to listing detail
						listingsWithType.push(row.tierConfig);

						const [lowestSortValue, sortByIndex] = getLowestSortValue(row.colGroups);

						if (row.colGroups.length !== 0) {
							// Don't show tier+1 button (touchAction 10) if this row has no child listings
							const effectiveTouchAction = (row.tierConfig.touchAction === 10 && (!row.listings || row.listings.length === 0))
								? 0
								: row.tierConfig.touchAction;

							lastEffectiveTouchAction = effectiveTouchAction;

							const { defaultList, ...propsWithoutDefaultList } = this.props;

							rowsArray.push(
								<ListingRow
									{...propsWithoutDefaultList}
									key={`details_row_${i}`}
									boxColumnsPerRow={row.tierConfig.boxColumnsPerRow + 1}
									boxActiveLayout={row.tierConfig.boxActiveLayout + 1}
									boxStyleDisplay={row.tierConfig.boxStyleDisplay}
									headerData={headersArray}
									data={listingsWithType}
									detailsGrp={row.detailsGrp}
									css={currentHeaderWidths}
									currentDetailAction={effectiveTouchAction}
									rowUUID={row.m1Key}
									addToHistory={this.addToHistory}
									detailsTitle={this.props.details[0]}
									setDetailsTitle={this.props.setDetailsTitle}
									setDetailsData={this.props.setDetailsData}
									sortByIndex={sortByIndex}
									sortByDirection={lowestSortValue > 0 ? row.colGroups[sortByIndex]?.sort_direction : 0}
									textAlign={textAlign}
									displayChildTier={this.props.displayChildTier}
									openWayfindingModal={this.props.openWayfindingModal}
									messageLabels={this.props.messageLabels}
									num={i}
								/>
							)
						}
					}
				});

				if (listing.listings.length > 0) {
					listing.listings[0].colGroups.forEach(colGroup => {
						rowHeaders.push(colGroup.name)
					});
				}
				if (!boxStyleDisplay) {
					tieredHeaders.push(
						<div
							className={`${css.header} listingsDetailsHeader`}
							key={`tieredHeader_${j}`}
							data-ts-id={`listingsDetailsHeader.${this.props.detailsUuid}`}
						>
							<ListingHeader
								{...this.props}
								data-key={`tieredHeader`}
								data={rowHeaders}
								css={headerWidths}
								textAlign={textAlign}
								currentDetailAction={touchAction}
							/>
						</div>
					)
				}

				if (numberOfResults >= 500) {
					tieredHeaders.unshift(
						<p
							className={`${css.overLimit} listingsDetailsTooManyResultsError`}
							data-ts-id={`listingsDetailsTooManyResultsError.${this.props.component_name}`}
						>
							{t("listingsTooManyResultsError")}
						</p>
					)
				}
			} else if (listing.listings && listing.listings.length > 0) {
				// Check if any of the rows in this listing group match the detailsUUID
				let foundMatchInRows = false;
				listing.listings.forEach((row) => {
					if (row.m1Key === this.props.detailsUUID) {
						foundMatchInRows = true;
						
						if (row.listings && row.listings.length > 0) {
							touchAction = row.tierConfig?.touchAction || touchAction;

							// Only process children if at least one has actual display data (non-empty colGroups)
							const hasDisplayableChildren = row.listings.some(child =>
								(child.colGroups && child.colGroups.length > 0) ||
								(child.listings && child.listings.some(gc => gc.colGroups && gc.colGroups.length > 0))
							);
							if (!hasDisplayableChildren) return;

							// Process child items - they can be listing groups or individual rows
							row.listings.forEach((childItem, idx) => {
								// If this child is a row (has colGroups/vals but no/empty listings), wrap it
								if (childItem.colGroups && childItem.vals && (!childItem.listings || childItem.listings.length === 0)) {
									// Create a temporary listing group wrapper and process it with forceProcess=true
									const wrappedChild = {
										m1Key: childItem.m1Key,
										listings: [childItem],
										tierConfig: childItem.tierConfig
									};
									this.buildListingsNew([wrappedChild], rowsArray, true);
								} else {
									// It's already a listing group, process with forceProcess=true
									this.buildListingsNew([childItem], rowsArray, true);
								}
							});
						}
					}
				});
				
				// If we didn't find a match in the rows, recurse into nested listing groups
				if (!foundMatchInRows) {
					this.buildListingsNew(listing.listings, rowsArray);
				}
			}

		});


		const uniqueRows = [...new Map(rowsArray.map((m) => [m.props.rowUUID, m])).values()];
		if (touchAction === 10) {
			// Only call handleShowChildren if we don't already have tiered data from history
			// This prevents re-adding history when going back via the back button
			const hasExistingTieredData = this.props.tieredDetails && this.props.tieredDetails.length > 0;
			if (!hasExistingTieredData) {
				this.handleShowChildren(uniqueRows, tieredHeaders);
			}
		}

		this.setState({
			tieredDetails: uniqueRows,
			tieredHeaders: tieredHeaders,
			touchAction: touchAction
		}, () => {
			if (isTopLevel && lastEffectiveTouchAction !== null) {
				this.context.setCurrentDetailAction(lastEffectiveTouchAction);
			}
			// Only set pathStyle after initial render is complete
			this.animateTimeout = setTimeout(() => {
				this.setState({ pathStyle: 'animatePath' });
			}, 1500);
			this.props.setDetailsHasRendered(true);
			// Only reset the depth counter if this is the top-level call
			if (isTopLevel) {
				this.buildingDepth = 0;
			} else {
				this.buildingDepth--;
			}
		});
	}

	handleDown = (buttonId) => {
		this.setState({ activeButton: buttonId })
	}

	handleUp = () => {
		this.setState({ activeButton: '' })
	}

	buildTextAlign = (textAlign) => {
		switch (textAlign) {
			case 0:
				return 'left'
			case 1:
				return 'center'
			case 2:
				return 'right'
			default:
				return 'center'
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.navProps.resetListings !== this.props.navProps.resetListings && this.props.navProps.resetListings === true) {
			this.handleClosePage();
			this.props.navEvents('setHasNavigatedListings', false);
		}

		if (prevProps.detailsUUID !== this.props.detailsUUID) {
			this.setState({
				markerEnd: '',
				markerStyle: '',
				pathStyle: '',
				iframeClosedByUser: false, // Reset flag when navigating to different listing
			});
			this.buildListingsNew(this.state.listings);
		}

		if (prevProps.showDetailsPage !== this.props.showDetailsPage && this.props.showDetailsPage === false) {
			this.setState({
				markerEnd: '',
				markerStyle: '',
				pathStyle: ''
			});
		}

		// Reset iframe closed flag when touch action changes (e.g., switching between views)
		if (prevProps.detailsTouchAction !== this.props.detailsTouchAction) {
			this.setState({
				iframeClosedByUser: false,
			});
		}

		if (JSON.stringify(prevProps.defaultList.listings) !== JSON.stringify(this.props.defaultList.listings)) {
			this.setState({
				listings: this.props.defaultList.listings,
			});
			// Rebuild rendered tier output so an open details view picks up the
			// refreshed data (e.g. scheduled-out child rows from a 15-min tick).
			// buildListingsNew uses its first arg, not state.listings, so passing
			// the new value directly is safe despite the pending setState above.
			this.buildListingsNew(this.props.defaultList.listings);
		}

		if (this.state.currentIframe !== prevState.currentIframe && this.state.currentIframe !== '') {
			this.props.navEvents('toggleIframe');
		}

	}

	addToHistory = () => {
		this.props.setHistory({
			detailsTitle: this.props.detailsTitle,
			tieredDetails: this.props.tieredDetails,
			tieredHeaders: this.props.tieredHeaders,
			type: 'listing',
			tierLevel: this.props.tierLevel,
			currentDetailAction: this.context.currentDetailAction
		});
	}

	// Optimize close handler
	handleClosePage = () => {
		// Batch state updates
		const newState = {
			markerEnd: '',
			markerStyle: '',
			pathStyle: '',
			showModal: false,
			showIframe: false,
			showVideo: false,
			currentPdf: '',
			currentIframe: '',
			currentVideo: ''
		};

		this.setState(newState, () => {
			this.props.navEvents('idleTimer', '||| ListingsDetails.js > handleClosePage()');
			this.props.setHistory([]);
			this.props.setTieredHeadersAndDetails([], []);

			requestAnimationFrame(() => {
				this.props.setDetailsUUID('');
				this.props.setDetailsAction(0);
				this.props.setDetailsHasRendered(false);
				this.props.setDetailsGrp([]);
				this.props.closeDetailsPage();
				this.props.setDetailsTitle('');
			});
		});

		dlClosePage();
	};

	triggerCloseButton = () => {
		console.log(`ListingDetails.js > triggerCloseButton()`);
		this.props.navEvents('idleTimer', '||| ListingsDetails.js > listingDetails()');
		this.props.goBack();
	}

	handleShowChildren = (tieredDetails, tieredHeaders) => {
		this.props.temporarilyDisableButton();
		
		let sortByIndex = tieredDetails[0].props.sortByIndex
		let sortByDir = tieredDetails[0].props.sortByDirection === 1 ? -1 : 1;
		let sortedTieredDetails = tieredDetails.sort(function (a, b) {
			return compareListingValues(a.props.data[sortByIndex]?.value, b.props.data[sortByIndex]?.value, sortByDir);
		});

		this.props.navEvents('idleTimer', '||| ListingsDetails.js > handleShowChildren()');
		this.props.setTieredHeadersAndDetails(tieredHeaders, sortedTieredDetails);
		this.props.setDetailsTitle(this.props.details[0].value);
		// React 19 fix: Call setHistory BEFORE closeDetailsPage so that
		// closeDetailsPage's updater function sees the pending history entry
		// and does not prematurely clear detailsHasRendered. With React 18+
		// automatic batching, all these setState calls are processed together,
		// and the updater in closeDetailsPage needs to see history.length > 0.
		this.props.setHistory({
			details: this.props.details,
			detailsUUID: this.props.detailsUUID,
			detailsGrp: this.props.detailsGrp,
			detailsTouchAction: this.props.detailsTouchAction,
			type: 'detail',
			tierLevel: this.props.tierLevel,
			currentDetailAction: this.context.currentDetailAction
		});
		this.props.closeDetailsPage();


		dlShowChildren({
			detailsTitle: this.props.details[0]?.value,
		});
	}

	buildDetailsSection = (array, section, dataType) => {
		let css = this.state.css;
		let labelSeperator = this.props.labelSeperator;

		// details data replaced when nearby locations clicked
		let detailsData = this.state.nearbyDetailsGrp ? this.state.nearbyDetailsGrp : this.props.detailsGrp;

		const lastDetail = this.props.details[this.props.details.length - 1];
		let detailsHeaderInfo = {
			detailHeaders: lastDetail?.detailHeaders,
			labelSeperator: lastDetail?.labelSeperator,
		};

		return (
			<DetailsSection
				detailsData={detailsData}
				css={css}
				detailsUUID={this.props.detailsUUID}
				config={{
					showHeaders: detailsHeaderInfo.detailHeaders,
					labelSeparator: labelSeperator[detailsHeaderInfo.labelSeperator],
					typeFilter: array,
					limitOneImage: this.props.detailsTouchAction === 5,
					section: section,
					dataType: dataType,
					touchAction: this.props.detailsTouchAction
				}}
				handlers={{
					onPdfClick: (value) => this.toggleModal(value),
					onVideoClick: (value) => this.toggleVideo(value),
					onUrlClick: (value) => this.toggleIframe(value),
					onButtonDown: (buttonId) => this.handleDown(buttonId),
					onButtonUp: () => this.handleUp(),
					navEvents: this.props.navEvents
				}}
				activeButton={this.state.activeButton}
			/>
		);
	}

	detailsPageType = () => {
		let css = this.state.css;
		let body = '';
		let detailActionToCheck = this.props.detailsTouchAction ? this.props.detailsTouchAction : this.context.currentDetailAction;

		if (detailActionToCheck === 4 || detailActionToCheck === 8 || detailActionToCheck === TOUCH_ACTION_DIRECT_WAYFINDING) { // Details Page A, Wayfinding Modal, Direct WF Modal (defensive — 14 never opens the page)
			body = (
				<>
					<div className={`${css.detailsLeft} detailsLeft`} data-ts-id={`listingsDetailsLeftA.${this.props.detailsUUID}`}>
						<div className={`${css.detailsTopLeft} detailsTopLeft`} data-ts-id={`listingsDetailsTopLeftA.${this.props.detailsUUID}`}>
							{this.buildDetailsSection(["Name", "Title"], 0, "Name")}
						</div>
						<div className={`${css.detailsBottomLeft} detailsBottomLeft`} data-ts-id={`listingsDetailsBottomLeftA.${this.props.detailsUUID}`}>
							{this.buildDetailsSection(["Address"], 1)}
							{this.buildDetailsSection(["Building", "Floor", "Location (apt/suite)"], 1)}
							{this.buildDetailsSection(["City", "State", "Zip"], 3)}
							{this.buildDetailsSection(["Primary Phone", "Phone"], 4)}
							{this.buildDetailsSection(["Text Small", "Text Medium", "Text Large", "Building Picker"], 6)}
						</div>
					</div>
					<div className={`${css.detailsRight} detailsRight`} data-ts-id={`listingsDetailsRightA.${this.props.detailsUUID}`}>
						{this.buildDetailsSection(["Logo", "Image", "Photo", "QR Code"], 7)}
					</div>
				</>
			)
		}
		if (this.props.detailsTouchAction === 5) { // Details Page B
			body = (
				<div className={`${css.detailsPageB} ${css.detailsCustom} detailsPageB`} data-ts-id={`listingsDetailsPageB.${this.props.detailsUUID}`}>
					<div className={`${css.detailsTopLeft} detailsTopLeft`} data-ts-id={`listingsDetailsTopLeftB.${this.props.detailsUUID}`}>
						{this.buildDetailsSection(["Name", "Title"], 0)}
					</div>
					<div className={`${css.detailsBottomLeft} detailsBottomLeft`} data-ts-id={`listingsDetailsBottomLeftB.${this.props.detailsUUID}`}>
						<div className={`${css.detailsPageBText} detailsPageBText`} data-ts-id={`listingsDetailsPageTextB.${this.props.detailsUUID}`}>
							{this.buildDetailsSection(["Text Large"], 1)}
						</div>
						{this.buildDetailsSection(["Image"], 2)}
					</div>
				</div>
			)
		}
		if (this.props.detailsTouchAction === 6 || this.props.detailsTouchAction === 7) { // Details Page C and Wayfinding A
			const detailsType = this.props.detailsTouchAction === 6 ? 'C' : 'WayfindingA';
			let fadeDetailsIn = css.opacity0;
			if (this.state.wayfindingReady === true) {
				fadeDetailsIn = css.opacity100;
			}

			body = (
				<>
					<div className={`${css.detailsWayfinding} detailsWayfinding ${fadeDetailsIn}`} data-ts-id={`listingsDetails${detailsType}.${this.props.detailsUUID}`}>
						{this.buildDetailsSection(["Name", "Title"], 0, "Name")}
						{this.buildDetailsSection(["Address"], 1, "Address")}
						{this.buildDetailsSection(["Building"], 2, "Building")}
						{this.buildDetailsSection(["Floor"], 3, "Floor")}
						{this.buildDetailsSection(["Location (apt/suite)"], 4, "Location")}
						{this.buildDetailsSection(["City", "State", "Zip"], 5, "Region")}
						{this.buildDetailsSection(["Primary Phone", "Phone"], 6, "Phone")}
						{this.buildDetailsSection(["Text Small", "Text Medium", "Text Large", "Building Picker"], 8, "Text")}
					</div>
					<div className={`${css.detailsWayfindingRight} detailsWayfindingRight ${fadeDetailsIn}`} data-ts-id={`listingsDetailsRight${detailsType}.${this.props.detailsUUID}`}>
						{this.buildDetailsSection(["Logo", "Image", "Photo", "QR Code"], 9, "Graphics")}
					</div>
				</>
			)
		}
		if (this.props.detailsTouchAction === 10) { // Details Tier+1
			body = (
				<></>
			)
		}
		if (this.props.detailsTouchAction === 11) { // iFrame URL
			let iframeActiveLabel;
			if (this.props.details && this.props.details.length > 0) {
				iframeActiveLabel = this.props.details[this.props.details.length - 1]?.iframeUrlLabel;
			}

			const urlItem = this.props.detailsGrp.find((obj) => {
				if (obj.label === "None") {
					return;
				}
				const matchedUrl = iframeActiveLabel === obj.label;
				return obj.type === "URL" && matchedUrl;
			});

			// Only auto-open iframe if user didn't explicitly close it
			if (this.state.currentIframe === '' && !this.state.iframeClosedByUser && urlItem && urlItem.value !== '') {
				this.toggleIframe(urlItem.value);
				body = (
					<></>
				)
			} else if (this.state.currentIframe === '' && !this.state.iframeClosedByUser) {
				this.toggleIframe('no source');
				body = (
					<></>
				)
			}
		}

		if (this.props.detailsTouchAction === 12) { // PDF Touch Action
			const fd = window.flatData
			let pdfValues = [];

			for (let [m1Key, m1Data] of Object.entries(fd)) {
				if (m1Key.startsWith('listing_group.')) {
					for (let [m2Key, m2Data] of Object.entries(m1Data)) {
						if (m2Key.startsWith('listing_config.')) {
							if (m2Data.pdf_url_label) {
								pdfValues.push(m2Data.pdf_url_label);
							}
						}
					}
				}
			}

			const pdfItem = this.props.detailsGrp.find((obj) => {
				if (obj.label === "None") {
					return;
				}
				const matchedPDF = pdfValues.find(pdfValue => pdfValue === obj.label);
				return obj.type === "PDF" && matchedPDF;
			});

			if (!this.state.currentPdf && pdfItem && !this.state.showModal) {
				this.setState({
					pdfItem: undefined,
				});
				this.toggleModal(pdfItem.value)
				body = (
					<></>
				)
			} else
				if (!pdfItem || pdfItem.value === '') {
					body = (
						<div className={`${css.noPdf} listingsDetailsNoPdf`} data-ts-id={`listingsDetailsNoPdf.${this.props.detailsUUID}`}>
							This Listing has no associated PDF.
						</div>
					)
				}
		}

		if (this.props.detailsTouchAction === 13) {
			const fd = window.flatData
			let videoValues = [];

			for (let [m1Key, m1Data] of Object.entries(fd)) {
				if (m1Key.startsWith('listing_group.')) {
					for (let [m2Key, m2Data] of Object.entries(m1Data)) {
						if (m2Key.startsWith('listing_config.')) {

							if (m2Data.video_url_label) {
								videoValues.push(m2Data.video_url_label);
							}
						}
					}
				}
			}

			const videoItem = this.props.detailsGrp.find((obj) => {
				if (obj.label === "None") {
					return;
				}
				const matchedvideo = videoValues.find(videoValue => videoValue === obj.label);
				return obj.type === "Video" && matchedvideo;
			});

			if (!this.state.currentVideo && videoItem?.value && !this.state.showModal) {
				this.setState({
					videoItem: undefined,
				});
				this.toggleVideo(videoItem.value)
				body = (
					<></>
				)
			} else
				if (!videoItem || videoItem.value === '') {
					body = (
						<div className={`${css.noVideo} listingsDetailsNoVideo`} data-ts-id={`listingsDetailsNoVideo.${this.props.detailsUUID}`}>
							This Listing has no associated Video.
						</div>
					)
				}
		}
		return body;
	}

	showMarker = () => {
		this.setState({
			markerEnd: 'url(#triangle)',
			markerStyle: 'showMarker'
		})
	}

	getNearbyLocationData = (key) => {
		const completeListings = window.completeListings;
		let listingDetails = [];

		completeListings.forEach((listingTier) => {
			listingTier.listings.forEach((listing) => {
				if (Array.isArray(listing) && listing[0] === key) {
					listingDetails = listing[listing.length - 1];
				}
			});
		});

		return listingDetails;
	}

	setNearbyLocationData = (key) => {
		const nearbyDetails = this.getNearbyLocationData(key);

		this.setState({
			nearbyDetailsGrp: nearbyDetails,
			useNearbyLocation: key
		});
	}

	// DEV-11237: info box CTA ("Details & Wayfinding") -> route the embedded
	// wayfinding + details to the tapped listing, same as picking a nearby
	// location (sets useNearbyLocation -> drives detailsUUID).
	handleInfoBoxOpenDetails = (matchedLocation) => {
		const key = matchedLocation?.listingUUID || matchedLocation?.key;
		if (key) {
			this.setNearbyLocationData(key);
		}
	}

	getQRTextInstruction = (listingConfigUUID) => {
		const {
			tmp_data_etl,
		} = this.props
		
		let qrText = 'Use your camera or tablet to take this map with you';
		let listingGroupUUID = '';

		for (let [m1Key, m1Data] of Object.entries(window.flatData)) {
			if (m1Key.startsWith('listing_group.')) {
				for (let [m2Key] of Object.entries(m1Data)) {
					if (m2Key === listingConfigUUID) {
						listingGroupUUID = m1Key;
					}
				}
			}
		}

		for (let [m1Key, m1Data] of Object.entries(tmp_data_etl)) {
			if (m1Key.startsWith('listing_collection.')) {
				for (let [m2Key, m2Data] of Object.entries(m1Data.listing_groups)) {
					if (m2Key === listingGroupUUID) {
						if (m2Data.settings.qrcode_text?.value) {
							qrText = m2Data.settings.qrcode_text.value;
						}
					}
				}
			}
		}

		return qrText;
	}

	buildWayfinding = () => {
		// Only render wayfinding after initial render
		if (this.props.detailsTouchAction === 7 && !this.state.wayfindingReady) {
			// Clear any pending timeouts
			if (this.wayfindingInitTimeout) {
				clearTimeout(this.wayfindingInitTimeout);
			}

			// Use longer delay and RAF for React 19 concurrent rendering
			this.wayfindingInitTimeout = setTimeout(() => {
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						if (this.mounted) {
							this.setState({ wayfindingReady: true }, () => {
								this.wayfindingMounted = true;
							});
						}
					});
				});
			}, 250); // Increased from 100ms for React 19
			return;
		}
		
		// For translation
		const { t } = this.props;
		const fd = window.flatData
		const detailsUUID = this.state.useNearbyLocation ? this.state.useNearbyLocation : this.props.detailsUUID;
		
		if (this.props.detailsTouchAction === 7 && this.state.wayfindingReady) {
			let primaryWayfindingColumn = '';
			let secondaryWayfindingColumn = '';
	
			for (let [m1Key, m1Data] of Object.entries(fd)) {
				if (m1Key.startsWith('listing_group.')) {
					for (let [m2Key, m2Data] of Object.entries(m1Data)) {
						if (m2Key.startsWith('listing_config.')) {
							if (m2Data.wf_column && fd[detailsUUID][`listing_column.${m2Data.wf_column}`]) {
								primaryWayfindingColumn = m2Data.wf_column;
							}
							if (m2Data.wf_fallback_column && fd[detailsUUID][`listing_column.${m2Data.wf_column}`]) {
								secondaryWayfindingColumn = m2Data.wf_fallback_column;
							}
						}
					}
				}
			}
	
			let landmarkIdentifier = fd[detailsUUID][`listing_column.${primaryWayfindingColumn}`]?.string || '';
			try {
				const parsed = JSON.parse(landmarkIdentifier);
				if (Array.isArray(parsed)) {
					landmarkIdentifier = parsed.length === 1 ? parsed[0] : parsed;
				}
			} catch (e) { /* not JSON, keep as string */ }

			const landmarkIdentifierFallback = fd[detailsUUID][`listing_column.${secondaryWayfindingColumn}`]?.string || '';

			let legacyBuildingName = '';
			let legacyLandmarkId = '';
			let legacyLocationName = '';

			this.props.detailsGrp.forEach((columnData) => {
				if (columnData.type === 'Building') {
					legacyBuildingName = columnData.value;
				}
				if (columnData.type === 'Location (apt/suite)' && columnData.label === 'landmark_id') {
					legacyLandmarkId = columnData.value;
				}
				if (columnData.type === 'Location (apt/suite)' && columnData.label !== 'landmark_id') {
					legacyLocationName = columnData.value;
				}
			});

			let listingConfigUUID = '';
			for (let [m1Key, m1Data] of Object.entries(window.flatData)) {
				if (m1Key.startsWith(detailsUUID)) {
					for (let [m2Key] of Object.entries(m1Data)) {
						if (m2Key.startsWith('listing_config.')) {
							listingConfigUUID = m2Key;
						}
					}
				}
			}

			const qrCodeText = this.getQRTextInstruction(listingConfigUUID);

			// Memoize flatData to prevent unnecessary re-renders
			// Use sorted keys for stable hashing
			const flatDataKeys = Object.keys(window.flatData || {}).sort().join(',');
			if (this.memoizedFlatDataHash !== flatDataKeys) {
				this.memoizedFlatData = window.flatData ? { ...window.flatData } : null;
				this.memoizedFlatDataHash = flatDataKeys;
			}

			return (
				<WayfindingComponent
					adaActive={this.props.navProps.adaActive}
					componentUUID={condorComponentENV}
					css={this.props.CSSModules['Wayfinding']}
					env={envENV}
					flatData={this.memoizedFlatData}
					isMobile={false}
					landmarkIdentifier={landmarkIdentifier}
					landmarkIdentifierFallback={landmarkIdentifierFallback}
					legacyBuildingName={legacyBuildingName}
					legacyLandmarkId={legacyLandmarkId}
					legacyLocationName={legacyLocationName}
					listingConfigUUID={listingConfigUUID}
					listingNameCol={this.props.details?.[0]?.column_uuid}
					listingUUID={detailsUUID}
					locationMarkerUse={this.props.locationMarkerUse}
					locationMarkerColor={this.props.locationMarkerColor}
					locationMarkerSize={this.props.locationMarkerSize}
					mapDelayIn={this.props.mapDelayIn}
					mapDelayOut={this.props.mapDelayOut}
					pathColor={this.props.pathColor}
					pathEndmarker={this.props.pathEndmarker}
					pathEndmarkerSize={this.props.pathEndmarkerSize}
					pathWidth={this.props.pathWidth}
					pathSpeed={this.props.pathSpeed}
					pathType={this.props.pathType}
					animIconColorBg={this.props.animIconColorBg}
					animIconColorFill={this.props.animIconColorFill}
					animIconType={this.props.animIconType}
					primaryWayfindingColumn={`listing_column.${primaryWayfindingColumn}`}
					qrCodeText={qrCodeText}
					ref={this.wayfindingRef}
					showInfoBox={this.props.wf_show_infobox}
					infoBoxScale={0.7}
					onInfoBoxOpenDetails={this.handleInfoBoxOpenDetails}
					setNearbyLocationData={this.setNearbyLocationData}
					showMapButtons={this.props.showMapButtons === false ? false : true}
					systemUUID={this.props.system_uuid}
					systemGroupUUID={this.props.systemGroup}
					wayfindingZoomPan={this.props.wayfinding_zoom_and_pan_on}
					/* Journey panel intentionally not wired here — it shows only in the
					   WayfindingModal (docked left), not on the inline listing-details map. */
				/>
			);
		}

		// Temporary solution until full wayfinding solution is developed, must use "Details Page C"
		let wayfinding = '';
		let markerStyle = '';
		let pathStyle = '';

		let path = '0';
		let pathLength = '0';
		let contTop = '0';
		let contLeft = '0';
		let contTransform = 'none';
		let showSystemLocation = false;
		let textTop = '0';
		let textMarginRight = '0';
		let textTransform = 'none';


		let tlc = condorComponentENV;

		// 41b987c8-1ce1-4aa4-816f-cbcfd74d4a19 -> Craig's Hybrid 2 - Caremount Test system
		// 43df6579-b532-47ce-95aa-172f47689c3f -> Craig's Hybrid - Caremount system
		// baddbdcd-ebd1-4bb1-9bf3-4f4688e26d20 -> Optum temp system citest
		// 3c4d9254-2676-4f0f-9699-c221b128c672 -> Optum Test Hybrid local 
		// 6e13f311-b019-432c-80a1-43d68d477f8a -> 110 S Bedford Main-1 (PT-55H-TO) -DIR27 - TOUCH
		// 5a6e1266-2e1c-4271-91c8-883d3df36b8a -> 110 S Bedford-2nd Floor (PT-55H-TO)-DIR26 - TOUCH
		// 7e467328-6e01-4129-98d0-6a3a0abf3095 -> 90 S Bedford/Main Floor-1 (PT-55H-TO) - DIR25 - TOUCH
		// 76eb67b3-e9fc-461b-8a66-d63acb2102c3 -> 90 S Bedford/Main-2 (PT-55H-TO) - DIR24 - TOUCH
		if (Array.isArray(this.props.detailsGrp)) {
			this.props.detailsGrp.forEach((detailsData) => {
				if (detailsData.type === 'Array' && detailsData.label.toLowerCase() === 'building list') {
					markerStyle = this.state.markerStyle;
					pathStyle = this.state.pathStyle;

					if (tlc === '41b987c8-1ce1-4aa4-816f-cbcfd74d4a19' ||
						tlc === '43df6579-b532-47ce-95aa-172f47689c3f' ||
						tlc === 'baddbdcd-ebd1-4bb1-9bf3-4f4688e26d20' ||
						tlc === '3c4d9254-2676-4f0f-9699-c221b128c672' ||
						tlc === '7e467328-6e01-4129-98d0-6a3a0abf3095' ||
						tlc === '76eb67b3-e9fc-461b-8a66-d63acb2102c3') {

						// YAH for building 90 (west side)
						contTop = '389px';
						contLeft = '519px';
						contTransform = 'rotate(180deg)';
						showSystemLocation = true;
						textTop = '2.2em';
						textMarginRight = '3px';
						textTransform = 'rotate(180deg)';
						switch (detailsData.value) {
							case '100':
								path = 'M560 393 L532 393 L532 303 L491 264 L491 235';
								pathLength = '203.586';
								break;
							case '110':
								path = 'M560 391 L453 391 L453 451 L413 451';
								pathLength = '279';
								break;
							default:
								break;
						}

					} else if (tlc === 'building 90b') { // replace with TLC UUID
						// YAH for building 90 (east side)
						contTop = '389px';
						contLeft = '601px';
						contTransform = 'rotate(180deg)';
						showSystemLocation = true;
						textTop = '2.2em';
						textMarginRight = '3px';
						textTransform = 'rotate(180deg)';
						switch (detailsData.value) {
							case '90':

								break;
							case '100':
								path = 'M635 393 L532 393 L532 303 L491 264 L491 235';
								pathLength = '278.586';
								break;
							case '110':
								path = 'M632 391 L453 391 L453 451 L413 451';
								pathLength = '279';
								break;
							default:
								break;
						}

					} else if (tlc === 'building 100') { // replace with TLC UUID
						// YAH for building 100
						contTop = '183px';
						contLeft = '407px';
						contTransform = 'rotate(270deg)';
						textTop = '2.2em';
						textMarginRight = '3px';
						textTransform = 'rotate(90deg)';
						showSystemLocation = true;
						switch (detailsData.value) {
							case '90':
								path = 'M488 221 L488 259 L532 301 L532 392 L566 391';
								pathLength = '223.842';
								break;
							case '110':
								path = 'M489 223 L489 265 L452 297 L452 450 L413 449';
								pathLength = '282.931';
								break;
							default:
								break;
						}

					} else if (tlc === 'building 110a') {
						// YAH for building 110 (west side)
						contTop = '411px';
						contLeft = '269px';
						contTransform = 'rotate(270deg)';
						textTop = '2.2em';
						textMarginRight = '3px';
						textTransform = 'rotate(90deg)';
						showSystemLocation = true;
						switch (detailsData.value) {
							case '90':
								path = 'M347 451 L450 451 L450 390 L564 390';
								pathLength = '278';
								break;
							case '100':
								path = 'M351 451 L451 451 L451 289 L490 258 L490 227';
								pathLength = '342.82';
								break;
							default:
								break;
						}

					} else if (tlc === '6e13f311-b019-432c-80a1-43d68d477f8a' ||
						tlc === '5a6e1266-2e1c-4271-91c8-883d3df36b8a') {
						// YAH for building 110 (east side)
						contTop = '449px';
						contLeft = '383px';
						contTransform = 'rotate(180deg)';
						textTop = '2.2em';
						textMarginRight = '3px';
						textTransform = 'rotate(180deg)';
						showSystemLocation = true;
						switch (detailsData.value) {
							case '90':
								path = 'M421 452 L451 452 L451 392 L570 391';
								pathLength = '209.004';
								break;
							case '100':
								path = 'M423 451 L451 451 L451 289 L490 258 L490 227';
								pathLength = '270.82';
								break;
							default:
								break;
						}

					}
				}
			})
		}

		let strokeStyles = {
			strokeDasharray: `${pathLength} ${pathLength}`,
			strokeDashoffset: pathLength
		}
		let markerContStyles = {
			top: contTop,
			left: contLeft,
			transform: contTransform
		}
		let textContStyles = {
			top: textTop,
			marginRight: textMarginRight,
			transform: textTransform
		}

		if (this.props.detailsTouchAction === 6 && showSystemLocation === true) {
			wayfinding =
				<div id="svgWrapper" className={`svgWrapper`}>
					<div className={`hereCont`} style={markerContStyles}>
						<div className={`hereMarker`}></div>
						<div className={`hereMarkerCircle`}></div>
						<div className={`hereText`} style={textContStyles}>{t("listingsYouAreHereLabel")}</div>
					</div>

					<svg id="svgArea" className={`svgArea`}>
						<marker id="triangle" viewBox="0 0 8 8" refX="5" refY="4" markerUnits="strokeWidth" markerWidth="5" markerHeight="5" orient="auto" >
							<path id="endMarker" className={`${`endMarker`} ${markerStyle}`} fill="red" d="M 0 0 L 0 8 L 8 4 z"></path>
						</marker>
						<path markerEnd={this.state.markerEnd} style={strokeStyles} onTransitionEnd={this.showMarker} className={`line0 ${pathStyle}`} strokeWidth="3" stroke="red" id="mainPath" d={path}></path>
					</svg>
				</div>
				;
		}

		return wayfinding;
	}

	wayfindingReplayBtn = () => {
		const {
			locationMarkerUse,
		} = this.props;
		let css = this.state.css;

		if (this.props.detailsTouchAction === 7 && !locationMarkerUse) {
			return (
				<div
					className={`${css.childDetailsBtn} childDetailsBtn childReplayBtn ${this.state.activeButton === 'wayfindingReplayBtn' ? `${css.activeButton} activeButton` : ''}`}
					data-ts-id={`listingsDetailsReplayPathBtn.${this.props.detailsUUID}`}
					onMouseDown={(e) => {
						e.stopPropagation();
						this.handleDown('wayfindingReplayBtn');
						this.props.navEvents(`btnDebouncer`, () => this.wayfindingRef.current?.reloadImage());
					}}
					onMouseUp={this.handleUp}
					onMouseLeave={this.handleUp}
					onTouchStart={(e) => {
						e.stopPropagation();
						this.handleDown('wayfindingReplayBtn');
						this.props.navEvents(`btnDebouncer`, () => this.wayfindingRef.current?.reloadImage());
					}}
					onTouchEnd={this.handleUp}
					onPointerDown={(e) => {
						e.stopPropagation();
						this.handleDown('wayfindingReplayBtn');
						this.props.navEvents(`btnDebouncer`, () => this.wayfindingRef.current?.reloadImage());
					}}
					onPointerUp={this.handleUp}
					onPointerLeave={this.handleUp}
				>
					<FontAwesomeIcon icon={faPlayCircle} className={`listingsSearchIcon ${css.searchIcon}`} /> Replay
				</div>
			);
		}
	}

	convertToCssClass = (str) => {
		const disallowedChars = /[^a-zA-Z0-9\-_]/g;

		if (str) {
			// Remove all spaces and disallowed CSS class characters
			const tierName = str.replace(/\s+/g, '').replace(disallowedChars, '');
			return `listingDetailsName${tierName}`
		} else {
			return '';
		}
	}

	render() {
		let css = this.state.css;
		let adaClass = '';
		const tier = `listingDetailsTier${parseInt(this.props.listingTier) + 1}`;
		const tierName = this.convertToCssClass(this.props.listingTierName);

		if (this.props.navProps.adaActive === true) {
			adaClass = css.adaActive;
		}

		let scrollType = '';
		if (this.props.scrollButtons === 2) {
			scrollType = css.smoothScroll;
		}

		let showManualScrolling = true;
		if (this.props.detailsTouchAction === 6) {
			showManualScrolling = false;
		}

		return (
			<>
				{this.props.detailsTouchAction !== 10 && (
					<CSSTransition
						in={this.props.detailsPage === true}
						appear={this.props.detailsPage === true}
						timeout={700}
						unmountOnExit
						classNames={`${css.contentFadeContainer} contentFade`}
						nodeRef={this.detailsRef}>
						<div
							ref={this.detailsRef}
							className={`${css.listingsContainer} listingsContainer ${tier} ${tierName} ${adaClass}`}
							data-ts-id={`listingsDetails.${this.props.component_name}`}
						>
							<div
								className={`${css.detailsPage} detailsPage`}
								data-ts-id={`listingsDetailsScroller.${this.props.component_name}`}
								id='listingsScrollerDetails'
							>
								<div
									className={`${css.detailsPageInner} detailsPageInner ${scrollType} ${css.listingsScroller} listingsScroller`}
									data-ts-id={`listingsDetailsPageInner.${this.props.component_name}`}
									ref={this.scrollWindow}
								>
									{this.buildWayfinding()}
									{this.detailsPageType()}
								</div>

								<div
									className={`${css.btnContainer} btnContainer`}
									data-ts-id={`listingsDetailsBtnContainer.${this.props.component_name}`}
								>
									{this.state.tieredDetails.length > 0 &&
										<div
											className={`${css.childDetailsBtn} childDetailsBtn childListingsBtn ${this.state.activeButton === 'showListingsButton' ? `${css.activeButton} activeButton` : ''}`}
											data-ts-id={`listingsDetailsChildrenBtn.${this.props.component_name}`}
											onMouseDown={(e) => {
												e.stopPropagation();
												this.handleDown('showListingsButton')
												this.props.navEvents(`btnDebouncer`, () => this.handleShowChildren(this.state.tieredDetails, this.state.tieredHeaders));
											}}
											onMouseUp={this.handleUp}
											onMouseLeave={this.handleUp}
											onTouchStart={(e) => {
												e.stopPropagation();
												this.handleDown('showListingsButton')
												this.props.navEvents(`btnDebouncer`, () => this.handleShowChildren(this.state.tieredDetails, this.state.tieredHeaders));
											}}
											onTouchEnd={this.handleUp}
											onPointerDown={(e) => {
												e.stopPropagation();
												this.handleDown('showListingsButton')
												this.props.navEvents(`btnDebouncer`, () => this.handleShowChildren(this.state.tieredDetails, this.state.tieredHeaders));
											}}
											onPointerUp={this.handleUp}
											onPointerLeave={this.handleUp}
										>
											Show {this.props.details[0]?.value} listings
										</div>
									}

									{this.buildDetailsSection(["PDF", "URL", "Video"], 5)}

									<div
										className={`${css.childDetailsBtn} childDetailsBtn childCloseBtn ${this.state.activeButton === 'closeButton' ? `${css.activeButton} activeButton` : ''}`}
										data-ts-id={`listingsDetailsCloseBtn.${this.props.component_name}`}
										onMouseDown={(e) => {
											e.stopPropagation();
											this.handleDown('closeButton');
										}}
										onMouseUp={(e) => {
											e.stopPropagation();
											this.handleUp();
											// React 19 fix: trigger on mouseUp
											this.props.navEvents(`btnDebouncer`, this.triggerCloseButton);
										}}
										onMouseLeave={this.handleUp}
										onTouchStart={(e) => {
											e.stopPropagation();
											this.handleDown('closeButton');
										}}
										onTouchEnd={(e) => {
											e.stopPropagation();
											this.handleUp();
											// React 19 fix: trigger on touchEnd
											this.props.navEvents(`btnDebouncer`, this.triggerCloseButton);
										}}
										onPointerDown={(e) => {
											e.stopPropagation();
											this.handleDown('closeButton');
										}}
										onPointerUp={(e) => {
											e.stopPropagation();
											this.handleUp();
											// React 19 fix: trigger on pointerUp
											this.props.navEvents(`btnDebouncer`, this.triggerCloseButton);
										}}
										onPointerLeave={this.handleUp}
									>
										Close
									</div>

									{this.wayfindingReplayBtn()}

									{showManualScrolling &&
										<div className={`${css.scrollBtnCont} scrollBtnCont`} data-ts-id={`listingsDetailsScrollBtnCont.${this.props.component_name}`}>
											<div
												className={`${css.scrollBtn} scrollBtn`}
												data-ts-id={`listingsDetailsScrollUpBtn.${this.props.component_name}`}
												onPointerDown={() => this.startScrolling('up')}
												onPointerUp={this.stopScrolling}
												onPointerLeave={this.stopScrolling}
												onPointerOut={this.stopScrolling}
												ref={this.scrollUpBtn}
											>
												<div
													className={`${css.scrollArrowUp} ${css.scrollArrow} scrollArrowUp scrollArrow`}
													data-ts-id={`listingsDetailsScrollUpArrow.${this.props.component_name}`}
												>
												</div>
												<div
													className={`${css.scrollBtnText} scrollBtnText`}
													data-ts-id={`listingsDetailsScrollUpText.${this.props.component_name}`}
												>
													Scroll Up
												</div>
											</div>
											<div
												className={`${css.scrollBtn} scrollBtn`}
												data-ts-id={`listingsDetailsScrollDownBtn.${this.props.component_name}`}
												onPointerDown={() => { this.startScrolling('down') }}
												onPointerUp={this.stopScrolling}
												onPointerLeave={this.stopScrolling}
												onPointerOut={this.stopScrolling}
												ref={this.scrollDownBtn}
											>
												<div
													className={`${css.scrollArrowDown} ${css.scrollArrow} scrollArrowDown scrollArrow`}
													data-ts-id={`listingsDetailsScrollDownArrow.${this.props.component_name}`}
												>
												</div>
												<div
													className={`${css.scrollBtnText} scrollBtnText`}
													data-ts-id={`listingsDetailsScrollDownText.${this.props.component_name}`}
												>
													Scroll Down
												</div>
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					</CSSTransition>
				)}

				<CSSTransition
					in={this.state.showModal === true}
					appear={this.state.showModal === true}
					timeout={700}
					unmountOnExit
					onExited={this.handleModalExited}
					classNames={`${css.contentFadeContainer} contentFade`}
					nodeRef={this.pdfRef}>
					<PdfComponent
							domRef={this.pdfRef}
							condor_component_group={this.props.condor_component_group}
							condor_configuration={this.props.condor_configuration}
							condor_theme={this.props.condor_theme}
							source={this.state.currentPdf || this.state.pdfItem} css={''}
							CSSModules={this.props.CSSModules}
							handleClose={this.closeModal}
							navEvents={this.props.navEvents}
					/>
				</CSSTransition>

				<CSSTransition
					in={this.state.showVideo === true}
					appear={this.state.showVideo === true}
					timeout={700}
					unmountOnExit
					onExited={this.handleModalExited}
					classNames={`${css.contentFadeContainer} contentFade`}
					nodeRef={this.videoRef}>
					<VideoComponent
							domRef={this.videoRef}
							source={this.state.currentVideo || this.state.videoItem}
							condor_component_group={this.props.condor_component_group}
							condor_configuration={this.props.condor_configuration}
							condor_theme={this.props.condor_theme}
							CSSModules={this.props.CSSModules}
							handleClose={this.closeModal}
							navEvents={this.props.navEvents}
					/>
				</CSSTransition>

				<CSSTransition
					in={this.state.showIframe === true}
					appear={this.state.showIframe === true}
					timeout={700}
					unmountOnExit
					onExited={this.handleModalExited}
					classNames={`${css.contentFadeContainer} contentFade`}
					nodeRef={this.iframeRef}>
					<Iframe
						{...this.props}
						domRef={this.iframeRef}
						source={this.state.currentIframe}
						isTouch={true}
						handleClose={this.closeModal} />
				</CSSTransition>
			</>
		)
	}
}

export default withTranslation()(ListingsDetails);
